// extracted by mini-css-extract-plugin
export default {"label":"EscrowShortageModal_label__UsLq2","button":"EscrowShortageModal_button__Kz7c3","footer":"EscrowShortageModal_footer__3+gJ7"};